'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _entitiesAlbum = require('./entities/Album');

var _entitiesAlbum2 = _interopRequireDefault(_entitiesAlbum);

var _entitiesArtist = require('./entities/Artist');

var _entitiesArtist2 = _interopRequireDefault(_entitiesArtist);

var _entitiesPlaylist = require('./entities/Playlist');

var _entitiesPlaylist2 = _interopRequireDefault(_entitiesPlaylist);

var _entitiesTrack = require('./entities/Track');

var _entitiesTrack2 = _interopRequireDefault(_entitiesTrack);

var _entitiesUser = require('./entities/User');

var _entitiesUser2 = _interopRequireDefault(_entitiesUser);

var _classesSession = require('./classes/Session');

var _classesSession2 = _interopRequireDefault(_classesSession);

exports['default'] = {
    Album: _entitiesAlbum2['default'],
    Artist: _entitiesArtist2['default'],
    Playlist: _entitiesPlaylist2['default'],
    Track: _entitiesTrack2['default'],
    User: _entitiesUser2['default'],
    Session: _classesSession2['default']
};
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/spotify-client/lib/index.js
 ** module id = 68
 ** module chunks = 0
 **/